import { useMemo } from "react";
import EvaluationContext from "../context";
import OneOption from "../components/OneOption";
import useIdleTimer from "../hooks/useIdleTimer";
import LoadingPage from "components/LoadingPage";
import useEvaluation from "../hooks/useEvaluation";
import ModalInternet from "components/ModalInternet";
import ModalErrorServer from "components/ModalErrorServer";
import ButtonEvaluation from "../components/ButtonEvaluation";
import HeaderEvaluation from "../components/HeaderEvaluation";
import TimerAndResponses from "../components/TimerAndResponses";
import {
  ModalAlertTwoMinutes,
  ModalEvaluationFinished,
  ModalInactivity,
  ModalNotResponse,
  ModalAlreadyResponse,
  ModalTimeFinished,
} from "../components/modals";
import { TIME_INACTIVE } from "utils/ConstantsAndNum";
import Skeleton from "../components/Skeleton";

const EvaluationPage = () => {
  const {
    isError,
    question,
    isLoading,
    isOpenModal,
    titleValue,
    isManyError,
    allQuestions,
    sendQuestion,
    isMinorTablet,
    remainingTime,
    getConfigModal,
    isLoadingFirst,
    isInactiveTimer,
    isErrorRemaining,
    handleNextQuestion,
    handleOptionOption,
    handleCloseFinishExam,
    handleOpenInactiveModal,
    handleCloseInactiveModal,
    handleOpenTimeFinishModal,
    handleCloseTimeFinishModal,
    handleCloseTwoMinutesModal,
    handleOpenTwoMinutesModal,
  } = useEvaluation();

  useIdleTimer(TIME_INACTIVE, isInactiveTimer, handleOpenInactiveModal);

  const divContainer = `bg-01 rounded-default flex flex-col mt-3 ${
    isMinorTablet ? "p-6" : "p-14"
  }`;

  const evaluationContext = useMemo(
    () => ({
      question,
      sendQuestion,
      allQuestions,
      isMinorTablet,
      isErrorRemaining,
      handleNextQuestion,
      handleOptionOption,
      handleOpenTimeFinishModal,
      handleOpenTwoMinutesModal,
    }),
    [
      question,
      sendQuestion,
      allQuestions,
      isMinorTablet,
      isErrorRemaining,
      handleNextQuestion,
      handleOptionOption,
      handleOpenTimeFinishModal,
      handleOpenTwoMinutesModal,
    ]
  );

  if (isLoadingFirst) {
    return <LoadingPage isLoading={isLoadingFirst} />;
  }
  return (
    <EvaluationContext.Provider value={evaluationContext}>
      <div className="bg-02 w-full h-full">
        <HeaderEvaluation isMinorTablet={isMinorTablet} title={titleValue}/>
        <div className="px-8 pb-8 max-w-base m-auto">
          <TimerAndResponses remainingTime={remainingTime} />
          <div className={divContainer}>
            <h1 className="font-normal  text-body-02 text-color-01">
            Importante: Lee atentamente cada pregunta y selecciona la opción que consideres más adecuada
            </h1>
            {isLoading || isErrorRemaining ? <Skeleton isMinorTablet={isMinorTablet} /> : <OneOption />}
            <ButtonEvaluation disabled={isLoading} />
          </div>
        </div>

        <ModalNotResponse
          isOpen={isOpenModal("notResponse")}
          config={getConfigModal("notResponse")}
        />

        <ModalInternet isOpen={isOpenModal('internet') } />

        <ModalAlertTwoMinutes
          isOpen={isOpenModal("twoMinutes")}
          onConfirm={handleCloseTwoMinutesModal}
        />
        <ModalInactivity
          isOpen={isOpenModal("inactive")}
          onConfirm={handleCloseInactiveModal}
        />
        <ModalTimeFinished
          isOpen={isOpenModal("timeFinish")}
          onConfirm={handleCloseTimeFinishModal}
        />
        <ModalEvaluationFinished
          isOpen={isOpenModal("finishExam")}
          onConfirm={handleCloseFinishExam}
        />

        <ModalErrorServer isOpen={isError} isManyError={isManyError} />

        <ModalAlreadyResponse isOpen={isOpenModal("alreadyResponse")} />
      </div>
    </EvaluationContext.Provider>
  );
};

export default EvaluationPage;
